import React from 'react';
const Card = ({ children, className }) => {
    return React.createElement("div", { className: 'ac-card ' + (className || '') }, children);
};
export { Card };
//# sourceMappingURL=Card.js.map